import React, { forwardRef, useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import './signaturepad.css'


const SignaturePad = forwardRef( (props, ref) => {
  // const getSignature = () => {
  //   setSignature(sigPad.current.getTrimmedCanvas().toDataURL('image/png'));
  // }

  // const clearSignature = () => {
  //   sigPad.current.clear();
  // };
  


  return (
    <>
      <Box sx={{ border: '1px solid gray', width: '100%', height: 350 }}>
        {props.signatory.signature && !props.showCanvas ?
        <div style={{ textAlign: 'center' }}>
        <img
            src={props.signatory.signature}
            alt="my signature"
            width='100%'
            height={350}
          />
        </div>
  
          :
          <SignatureCanvas
            penColor='black'
            canvasProps={{ className: 'sigCanvas' }}
            ref={ref}
          />
        }

      </Box>
    </>
  )
})

export default SignaturePad;